<template>
    <div class="row">
        <div class="form-group col-sm-4">
            <div class="toggle-switch float-right">
                <input type="hidden" :name="name" value="0">
                <input type="checkbox" class="toggle-switch__checkbox" :id="id" :name="name" :checked="isChecked" @input="$emit('input')">
                <i class="toggle-switch__helper"></i>
            </div>
        </div>
        <div class="col-sm-8 field-label text-left">{{ label }}</div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'

    export default {
        mixins: [formElementMixin],

        computed: {
            isChecked() {
                if(this.value+'' == '1' || this.value == true || this.value == 'on'){
                    return true;
                }

                return false;
            }
        }

    }
</script><style lang="scss">@import "@/assets/scss/components/form_elements/_switch.scss";</style>